module.exports = __webpack_public_path__ + "static/placeholder-bac728e325e57f2723325b706d3536e8.jpg";